var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#2d2d2d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(8)",
    fill: "#2d2d2d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(16)",
    fill: "#2d2d2d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(0 8)",
    fill: "#2d2d2d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(8 8)",
    fill: "#2d2d2d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(16 8)",
    fill: "#2d2d2d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(0 16)",
    fill: "#2d2d2d"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(8 16)",
    fill: "#2d2d2d"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(16 16)",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcher);
export default __webpack_public_path__ + "static/media/switcher.9b5c26de05412c841560e7a89fa7d7b3.svg";
export { ForwardRef as ReactComponent };